var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonRightBorderreact = function SvgButtonRightBorderreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.88 107",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M0 1h29.83v17.93h-2.27a7.87 7.87 0 0 0-5.25 1.44 8 8 0 0 0-2.44 4.45 61.37 61.37 0 0 0-.41 9c0 4.9-2.45 8.74-3.45 11.55a12.79 12.79 0 0 1-3.15 5.25l-.17.15a3.94 3.94 0 0 0-.3 5.56l.37.37.48.45a14.62 14.62 0 0 1 3.06 5.55c.84 2.49 3.16 6.47 3.16 11.94a38.33 38.33 0 0 0 .76 9.62 5.28 5.28 0 0 0 2.63 3.15c1.18.62 3.52.93 7 .95V106H0"
  })));
};

export default SvgButtonRightBorderreact;